// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"346":"588a70b7","437":"6b8ae820","634":"953dbf18","918":"3f7cf98a"}[chunkId] + ".chunk.css";
};